<template>
  <div class="container notify-page section fullscreen-content">
    <div class="notification">
      <h1 v-if="notify.title!=false">{{ $t(notify.title) }}</h1>
      <p>{{ $t(notify.content) }}</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  created () {
    if (this.notify.title === '' && this.notify.content === '') {
      this.$router.push({ name: 404 })
    }
  },
  computed: mapState(['notify'])
}
</script>
<style lang="scss">
.notify-page {
  padding-top: 130px;
}
.notification {
  max-width: 600px;
  padding: 30px;
  box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.12);
  margin: auto;
  margin-top: 50px;
  text-align: center;

  @include mq($ms){
    margin-top: 0;
  }

  h1 {
    margin: 0;
    font-size: 24px;
  }
  p {
    margin-bottom: 0;
    line-height: 30px;
  }
}
</style>
